import { SESSION_TYPE } from '../constants';
import { ClusterId } from '../slices/clusters';
import { EquipmentSessionId, NormalizedEquipmentSession } from '../slices/sessions';
import { Values } from './types';

export const trackHasClusterColor = (clusterId: ClusterId, colorItem?: { id?: unknown }) => {
  return String(clusterId) === String(colorItem?.id);
};

export const trackHasEquipmentColor = (equipmentId: string, colorItem?: { id?: unknown }) => {
  return String(equipmentId) === String(colorItem?.id);
};

export const defaultTrackColor = '#B5E936';
export const equipmentSessionTrackColor = '#169DEA';

type TrackFeature = {
  type?: string;
  geometry?: unknown;
  properties: {
    equipment_session_id?: EquipmentSessionId;
    cluster_id?: ClusterId;
    [key: string]: unknown;
  };
};

export type SessionTracks = {
  type?: string;
  features?: TrackFeature[];
};

export function decorateSessionTracks(
  tracks: SessionTracks | null | undefined,
  equipmentSessionById: Record<EquipmentSessionId, NormalizedEquipmentSession | undefined>,
  sessionType: Values<typeof SESSION_TYPE>,
) {
  if (!tracks?.features) {
    return tracks;
  }
  return {
    ...tracks,
    features: tracks.features.map((feature) => ({
      ...feature,
      properties: {
        ...feature.properties,
        sessionType,
        sessionStatus: feature.properties.equipment_session_id
          ? equipmentSessionById[feature.properties.equipment_session_id]?.processingStatus
          : undefined,
      },
    })),
  };
}
